import { apiRequest } from "../lib/apiClient";
import type { ExchangeRateCreate, ExchangeRateOut } from "./types";

/** `GET /exchange-rates` — any authenticated user, ordered `effective_at DESC`. */
export async function listExchangeRates(
  accessToken: string,
  filters: { fromCurrency?: string; toCurrency?: string } = {},
): Promise<ExchangeRateOut[]> {
  return apiRequest<ExchangeRateOut[]>("/exchange-rates", {
    accessToken,
    query: { from_currency: filters.fromCurrency, to_currency: filters.toCurrency },
  });
}

/** `POST /exchange-rates` — OWNER/ACCOUNTANT only. No PATCH exists — corrections are a
 * new row with a later `effective_at`. */
export async function createExchangeRate(accessToken: string, body: ExchangeRateCreate): Promise<ExchangeRateOut> {
  return apiRequest<ExchangeRateOut>("/exchange-rates", { method: "POST", accessToken, body });
}

/** `DELETE /exchange-rates/{id}` — OWNER/ACCOUNTANT only. Soft delete only. */
export async function deleteExchangeRate(accessToken: string, exchangeRateId: string): Promise<void> {
  await apiRequest<void>(`/exchange-rates/${exchangeRateId}`, { method: "DELETE", accessToken });
}
